export const getCitiesRefreshTargets = (countryId, countryFrom, countryTo) => ({
  from: countryFrom?.id === countryId,
  to: countryTo?.id === countryId,
});
